import React, {FC} from 'react';

import {KeyboardActionsEnum} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {StyledPopoverHeaderDiv} from './popoverCalendarEventViewerHeader';

/*
 * Props.
 */

export interface PopoverArbitraryCalendarEventViewerHeaderProps {
  onRequestClose: Handler;
}

/*
 * Component.
 */

export const PopoverArbitraryCalendarEventViewerHeader: FC<PopoverArbitraryCalendarEventViewerHeaderProps> = (
  props,
) => {
  const theme = useUserTheme();
  const {onRequestClose} = props;

  return (
    <StyledPopoverHeaderDiv>
      <IconButton
        iconName="close"
        onClick={onRequestClose}
        label={<Trans id="arbitrary-calendar-event-viewer-header-close">Close</Trans>}
        keyboardAction={KeyboardActionsEnum.CLOSE}
        color={theme.greys.shade80}
        hoverColor={theme.greys.shade80}
      />
    </StyledPopoverHeaderDiv>
  );
};
